module.exports = {"type":"object","properties":{"voter":{"title":"Voter","type":"string","x-schema-form":{"type":"entitylookup","lookuptype":"contact"}},"weight":{"title":"Weight","type":"number","minimum":1,"description":"Relative Weight of Lot/Unit, e.g. 1.0 vote per 1-bedroom unit and 1.25 votes for 2-bedroom units"},"blocked":{"type":"boolean","title":"Blocked","description":"The voter is not allowed to cast a vote for this property currently"},"votingCertificate":{"type":"string","title":"Voting Certificate","x-schema-form":{"type":"single-file-upload"}}},"required":[]}


//////////////////
// WEBPACK FOOTER
// ./client/components/schemas/evoting.json
// module id = 583
// module chunks = 0